import { NgModule, LOCALE_ID, TRANSLATIONS_FORMAT, TRANSLATIONS } from '@angular/core';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppSharedModule } from './app-shared.module';
import { SharedModule } from './shared/shared.module';
import { COMPOSITION_BUFFER_MODE } from '@angular/forms';

import {
  REST_SERVER_HOST,
  REST_API_V5_HOST,
  REST_SERVER_DB_SHARD_ID,
  AUTH_FRONT_HOST,
  SUPPORT_HOST,
} from '@schoolbelle/api/tokens';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from './shared/services/v5/auth';
import { REST_SERVER_HOST as V5_REST_SERVER_HOST, MOBILE_HOST as V5_MOBILE_HOST } from './shared/services/v5/tokens';
import { TranslateModule } from '@ngx-translate/core';
import {
  createSbeXlfAppTranslateModuleConfig,
  provideSbeTranslateServiceInitializer,
} from '@schoolbelle/common/translation';

@NgModule({
  imports: [
    BrowserAnimationsModule,

    AppRoutingModule,
    AppSharedModule,
    SharedModule.forRoot(),
    TranslateModule.forRoot(createSbeXlfAppTranslateModuleConfig()),
    // MainModule,
    // LoginModule,
  ],
  declarations: [AppComponent],
  providers: [
    provideSbeTranslateServiceInitializer(),
    { provide: COMPOSITION_BUFFER_MODE, useValue: false },
    {
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
      deps: [PlatformLocation],
    },
    {
      provide: REST_SERVER_DB_SHARD_ID,
      useFactory: (locale: string) => {
        let region = new URLSearchParams(window.location.search).get('region') || locale.slice(0, 2);
        switch (region) {
          case 'vi':
            return '1';
          default:
            return '0';
        }
      },
      deps: [LOCALE_ID],
    },
    {
      provide: REST_SERVER_HOST,
      useFactory: (db_id: string) => {
        if (db_id === '1' && environment.serverHost.startsWith('https')) {
          return 'https://vi.schoolbell-e.com/api';
        } else {
          return environment.serverHost;
        }
      },
      deps: [REST_SERVER_DB_SHARD_ID],
    },
    {
      provide: AUTH_FRONT_HOST,
      useFactory: (db_id: string) => {
        if (environment.serverHost.startsWith('https')) {
          if (db_id === '1') {
            return `${environment.authFrontHost}/vi`; // detached
          } else {
            return `${environment.authFrontHost}`; // shared
          }
        } else {
          return environment.authFrontHost;
        }
      },
      deps: [REST_SERVER_DB_SHARD_ID],
    },
    {
      provide: SUPPORT_HOST,
      useFactory: (locale: string) => {
        if (environment.supportHost.startsWith('https://')) {
          return `${environment.supportHost}/${locale.slice(0, 2)}`;
        }
        return environment.supportHost;
      },
      deps: [LOCALE_ID],
    },
    { provide: REST_API_V5_HOST, useValue: environment.restApiV5Host },

    // v5
    { provide: V5_REST_SERVER_HOST, useValue: environment.restApiV5Host },
    { provide: V5_MOBILE_HOST, useValue: environment.mobileV5Host },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
